<template>
  <div class="about">
    <section class="page-section">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1 class="section-title">
              {{ $t('label.title.aboutCashHero') }}
            </h1>
          </div>
          <template v-if="$i18n.locale === 'en'">
            <about-us-english />
          </template>
          <template v-else>
            <about-us-khmer />
          </template>
        </div>
      </div>
    </section>

    <div
      class="container d-flex d-md-block justify-content-center"
      style="padding-bottom: 4em"
    >
      <div style="width: 300px;">
        <!--change redirect to home page-->
        <router-link :to="{name: default_page}">
          <button class="full-button">
            {{ $t('button.getCashToday').toUpperCase() }}
          </button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import AboutUsEnglish from './../components/documents/aboutUs/AboutUsEnglish'
import AboutUsKhmer from './../components/documents/aboutUs/AboutUsKhmer'

export default {
  name: 'About',
  components: { AboutUsEnglish, AboutUsKhmer },
  metaInfo: {
    title: 'About',
    titleTemplate: '%s | Cash Hero',
    meta: [
      { charset: 'utf-8' },
      { name: 'description', content: 'About Cash hero website' }
    ]
  },
  data () {
    return {
      default_page: this.$default_page
    }
  }
}
</script>

<style scoped>
.service-item {
  margin-bottom: 25px;
  margin-left: 20px;
  margin-right: 20px;
}

.service-img-container {
  margin-bottom: 10px;
}

.subtitle-container {
  margin: 30px 0;
}
</style>
